import { render, staticRenderFns } from "./ValidationErrorList.vue?vue&type=template&id=13cadbda&scoped=true&"
import script from "./ValidationErrorList.vue?vue&type=script&lang=js&"
export * from "./ValidationErrorList.vue?vue&type=script&lang=js&"
import style0 from "./ValidationErrorList.vue?vue&type=style&index=0&id=13cadbda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cadbda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13cadbda')) {
      api.createRecord('13cadbda', component.options)
    } else {
      api.reload('13cadbda', component.options)
    }
    module.hot.accept("./ValidationErrorList.vue?vue&type=template&id=13cadbda&scoped=true&", function () {
      api.rerender('13cadbda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ValidationErrorList.vue"
export default component.exports